import React from 'react';
import ReactDOM from 'react-dom';
import '@crema/services';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Comprehensive ResizeObserver error suppression
const originalError = console.error;
const originalWarn = console.warn;

// Override console.error to suppress ResizeObserver errors
console.error = (...args) => {
  const message = args[0];
  if (typeof message === 'string' && 
      (message.includes('ResizeObserver loop completed with undelivered notifications') ||
       message.includes('ResizeObserver loop limit exceeded') ||
       message.includes('ResizeObserver'))) {
    return; // Suppress ResizeObserver errors
  }
  originalError.apply(console, args);
};

// Override console.warn to suppress ResizeObserver warnings
console.warn = (...args) => {
  const message = args[0];
  if (typeof message === 'string' && message.includes('ResizeObserver')) {
    return; // Suppress ResizeObserver warnings
  }
  originalWarn.apply(console, args);
};

// Global error handler for all errors
window.addEventListener('error', (event) => {
  if (event.message && 
      (event.message.includes('ResizeObserver') || 
       event.message.includes('loop completed with undelivered notifications'))) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }
});

// Handle unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && 
      event.reason.message && 
      event.reason.message.includes('ResizeObserver')) {
    event.preventDefault();
    return false;
  }
});

// Override ResizeObserver completely to prevent loop errors
if (window.ResizeObserver) {
  const OriginalResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class extends OriginalResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        // Use requestAnimationFrame to defer the callback
        requestAnimationFrame(() => {
          try {
            callback(entries, observer);
          } catch (error) {
            // Silently ignore ResizeObserver errors
            if (error.message && error.message.includes('ResizeObserver')) {
              return;
            }
            // Re-throw other errors
            throw error;
          }
        });
      });
    }
  };
}

// Additional error boundary for React errors
window.addEventListener('error', (event) => {
  if (event.error && event.error.message && event.error.message.includes('ResizeObserver')) {
    event.preventDefault();
    return false;
  }
});

ReactDOM.render(<App />, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
